import { useLocalTranslation } from '@/hooks/useLocalTranslation';

import GuardianName from "@/pages/profile/sections/bssDetails/sections/guardianName"
import GuardianContactNumber from "@/pages/profile/sections/bssDetails/sections/guardianContactNumber"
import BloodGroup from "@/pages/profile/sections/bssDetails/sections/bloodGroup"
import UgDegreeList from "@/pages/profile/sections/bssDetails/sections/ugDegreeList"
import UgInstitute from "@/pages/profile/sections/bssDetails/sections/ugInstitute"
import RegistrationNumber from "@/pages/profile/sections/bssDetails/sections/registrationNumber"
import PassingYear from "@/pages/profile/sections/bssDetails/sections/passingYear"
import AadharCard from "@/pages/profile/sections/bssDetails/sections/aadharCard"
import PanCard from "@/pages/profile/sections/bssDetails/sections/panCard"
import OtherDocs from "@/pages/profile/sections/bssDetails/sections/otherDocs"
import Signature from "@/pages/profile/sections/bssDetails/sections/signature"

import "./style.css"

export default function BssDetailsView(props: any) {
    const { profile } = useLocalTranslation();

    // Signature Com is 2 times because profileStepNo 10 is the last step, at profileStepNo 11 i am showing a toaster and want the com to be Signature hecne it is twice
    const componentMap: any = [
        <GuardianName
            errMsg={props.errMsg}
            handleInputChange={props.handleInputChange}
            value={props.guardianName}
            isSubmitBtnLoading={props.isSubmitBtnLoading}
            handleSubmit={props.handleSubmit}
        />,
        <GuardianContactNumber
            errMsg={props.errMsg}

            guardianCountryCode={props.guardianCountryCode}
            guardianContactNumber={props.guardianContactNumber}
            guardianContactNumberPlaceholder={profile.placeHolders.guardianContactNumber}

            handleInputChange={props.handleInputChange}
            handleSubmit={props.handleSubmit}
            isSubmitBtnLoading={props.isSubmitBtnLoading}
        />,
        <BloodGroup
            errMsg={props.errMsg}
            handleInputChange={props.handleInputChange}
            value={props.bloodGroup}
            isSubmitBtnLoading={props.isSubmitBtnLoading}
            handleSubmit={props.handleSubmit}
        />,
        <UgDegreeList
            errMsg={props.errMsg}
            handleInputChange={props.handleInputChange}
            value={props.ugDegree}
            isSubmitBtnLoading={props.isSubmitBtnLoading}
            handleSubmit={props.handleSubmit}
        />,
        <UgInstitute
            errMsg={props.errMsg}
            handleInputChange={props.handleInputChange}
            value1={props.underGraduateInstituteName}
            value2={props.underGraduateInstituteAddress}
            isSubmitBtnLoading={props.isSubmitBtnLoading}
            handleSubmit={props.handleSubmit}
        />,
        <RegistrationNumber
            errMsg={props.errMsg}
            handleInputChange={props.handleInputChange}
            value={props.registrationNumber}
            isSubmitBtnLoading={props.isSubmitBtnLoading}
            handleSubmit={props.handleSubmit}
        />,
        <PassingYear
            errMsg={props.errMsg}
            handleInputChange={props.handleInputChange}
            value={props.passingYear}
            isSubmitBtnLoading={props.isSubmitBtnLoading}
            handleSubmit={props.handleSubmit}
        />,
        <AadharCard
            errMsg={props.errMsg}
            handleInputChange={props.handleInputChange}
            value={props.aadharCard}
            isSubmitBtnLoading={props.isSubmitBtnLoading}
            handleSubmit={props.handleSubmit}
        />,
        <PanCard
            errMsg={props.errMsg}
            handleInputChange={props.handleInputChange}
            value={props.panCard}
            isSubmitBtnLoading={props.isSubmitBtnLoading}
            handleSubmit={props.handleSubmit}
        />,
        <OtherDocs
            errMsg={props.errMsg}
            handleInputChange={props.handleInputChange}
            value={props.otherDocs}
            isSubmitBtnLoading={props.isSubmitBtnLoading}
            handleSubmit={props.handleSubmit}
        />,
        <Signature
            errMsg={props.errMsg}
            handleInputChange={props.handleInputChange}
            signature={props.signature}
            placeOfSignature={props.placeOfSignature}
            dateOfSignature={props.dateOfSignature}
            bssAcknowledged={props.bssAcknowledged}
            handleOnCheckBoxChanged={props.handleOnCheckBoxChanged}
            isSubmitBtnLoading={props.isSubmitBtnLoading}
            handleSubmit={props.handleSubmit}
        />,
        <Signature
            errMsg={props.errMsg}
            handleInputChange={props.handleInputChange}
            signature={props.signature}
            placeOfSignature={props.placeOfSignature}
            dateOfSignature={props.dateOfSignature}
            bssAcknowledged={props.bssAcknowledged}
            handleOnCheckBoxChanged={props.handleOnCheckBoxChanged}
            isSubmitBtnLoading={props.isSubmitBtnLoading}
            handleSubmit={props.handleSubmit}
        />
    ];
    const ComponentToRender = componentMap[props.profileStepNo];
    // const ComponentToRender = componentMap[2];

    return (
        <div
        className={`bssDetailsViewMain
        rounded-[10px] profileSectionCommonMainCon`}>
            <h1
                style={{
                    marginBottom: "25px"
                }}
                className='commonH1'>{profile.bssSection.heading}</h1>
            {ComponentToRender || null}
        </div>
    );
}
